import { matchSorter } from 'match-sorter';
import { useContext } from 'react';
import AppContext from '../../../common/containers/AppContext';

function filterList(list, query) {
    if (!list?.length) {
        return [];
    }
    return matchSorter(list, query ?? '', { keys: ['label'] });
}

export default function useGetRevSearchResults(searchText) {
    const { products, customers, defaultSearchOptions } = useContext(AppContext);

    const filteredProducts = searchText ? filterList(products, searchText) : defaultSearchOptions;
    const filteredCustomers = filterList(customers, searchText);

    return [filteredProducts, filteredCustomers];
}
